import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@app/core/services/AuthenticationService';

@Injectable({ providedIn: 'root' })
export class MemberMessagesGuard {
  constructor(private auth: AuthenticationService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.auth.token) return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    if (route.data.adminMessages && (!this.auth.userHasRole('admin') || this.auth.isImpersonating()))
      return this.router.createUrlTree(['/messages']);
    return true;
  }
}
